import { render } from "./Box.vue?vue&type=template&id=44efd7b7&scoped=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-44efd7b7"

export default script